import React from "react";
import styled from "@emotion/styled";

type BadgeType = "primary" | "secondary";

type BadgeProps = {
  children: React.ReactNode;
  badgeType?: BadgeType;
  fitContent?: boolean;
};
function Badge(props: BadgeProps) {
  const { children, badgeType = "primary", ...rest } = props;
  return (
    <Wrapper badgeType={badgeType} {...rest}>
      {children}
    </Wrapper>
  );
}

export default Badge;

const Wrapper = styled.div<Omit<BadgeProps, "children">>(({ theme, badgeType, fitContent }) => ({
  color: theme.colors.white,
  display: "flex",
  fontFamily: "Inter, sans-serif",
  width: fitContent ? "fit-content" : 20,
  gap: 8,
  padding: fitContent ? "4px 8px" : "4px 4px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: 9999, // Large number so it's always fully rounded
  ...(badgeType === "primary" && {
    backgroundColor: theme.colors.sysPrimaryDefault,
  }),
  ...(badgeType === "secondary" && {
    backgroundColor: theme.colors.sysTextDefault,
  }),
}));
